"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_TREND_SEARCH = exports.TELE_SEARCH = exports.RECENT_TRENDING_SEARCH = exports.DOCTOR_SPECIALITY_SEARCH = exports.DOCTOR_FACILITY_SEARCH = exports.AUTO_SUGGESTION_SEARCH = void 0;
const RECENT_TRENDING_SEARCH = exports.RECENT_TRENDING_SEARCH = 'recentSearches';
const TOP_TREND_SEARCH = exports.TOP_TREND_SEARCH = 'topTrendSearches';
const TELE_SEARCH = exports.TELE_SEARCH = 'teleSearches';
const DOCTOR_SPECIALITY_SEARCH = exports.DOCTOR_SPECIALITY_SEARCH = 'doctorSpecialitySearch';
const DOCTOR_FACILITY_SEARCH = exports.DOCTOR_FACILITY_SEARCH = 'doctorFacilitySearch';
const AUTO_SUGGESTION_SEARCH = exports.AUTO_SUGGESTION_SEARCH = 'autoSuggestionSearch';